import React from 'react'
import PropTypes from 'prop-types'
import { connectToggleRefinement } from 'react-instantsearch-dom'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import MenuItem from '@material-ui/core/MenuItem'
import { PillSelect } from './Refiners.styles'

const CustomToggleRefinement = ({
  currentRefinement,
  label,
  count,
  refine,
}) => {
  const openForRegCount = count.unchecked ? `(${count.unchecked})` : '(0)'

  return (
    <PillSelect
      variant="outlined"
      value={currentRefinement || ''}
      displayEmpty
      IconComponent={KeyboardArrowDownIcon}
      renderValue={() => { return currentRefinement ? label : 'Registration' }}
    >
      <MenuItem>
        <FormControlLabel
          control={<Checkbox checked={currentRefinement} color="primary" />}
          label={`${label} ${openForRegCount}`}
          labelPlacement="end"
          onChange={() => refine(!currentRefinement)}
        />
      </MenuItem>
    </PillSelect>
  )
}

CustomToggleRefinement.propTypes = {
  currentRefinement: PropTypes.bool.isRequired,
  refine: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  count: PropTypes.shape({
    checked: PropTypes.number,
    unchecked: PropTypes.number,
  }),
}

export default connectToggleRefinement(CustomToggleRefinement)
